<template>
    <div class="chronicle">
        <!--<img class="dzxcsc" src="@/assets/images/dzxcsc.png" />-->
        <p class="title">发展历程</p>
        <div class="sides">
            <a> </a>
            <a class="short"> </a>
            <a class="short"> </a>
            <a class="short"> </a>
        </div>
        <el-row type="flex" class="row-bg wire" justify="center">
            <el-col :span="24">
                <div class="line"></div>
                <el-row type="flex" class="row-bg" justify="center">
                    <el-col :span="20" class="inner">
                        <el-col
                            class="main"
                            v-for="(item, index) in list"
                            :key="index"
                        >
                            <div
                                class="circular"
                                @click="arrive(item.annual)"
                                :class="{ active: currentpage == item.annual }"
                            >
                                <p class="hold">{{ item.annual | yeartext }}</p>
                                <i
                                    class="icon iconfont icon-iconfontyingyongjiasu"
                                ></i>
                            </div>
                        </el-col>
                        <el-col class="main">
                            <div class="circular">
                                <i class="el-icon-more icon"></i>
                            </div>
                        </el-col>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <fifteen ref="fifteenmain" />
    </div>
</template>
<script>
import fifteen from "@/views/summary/fifteen";
// import sixteen from "@/views/summary/sixteen";
// import seventeen from "@/views/summary/seventeen";
// import eighteen from "@/views/summary/eighteen";
// import nineteen from "@/views/summary/nineteen";
import { companyhistoryyear } from "@/api/apiall";
export default {
    components: {
        fifteen
        // sixteen,
        // seventeen,
        // eighteen,
        // nineteen
    },
    data() {
        return {
            list: [],
            currentpage: "",
            rulefrom: {
                annual: "",
                categoryId: "",
                platform: 1
            }
        };
    },
    mounted() {},
    created() {
        this.rulefrom.categoryId = this.$route.query.id;
        this.searchyear();
    },
    methods: {
        searchyear() {
            companyhistoryyear({ platform: 1 }).then(res => {
                if (res.status == 2000) {
                    this.list = res.data;
                    this.currentpage = res.data[res.data.length - 1].annual;
                    this.rulefrom.annual = res.data[res.data.length - 1].annual;
                    this.$refs.fifteenmain.searchmain(this.rulefrom);
                }
            });
        },
        arrive(data) {
            this.currentpage = data;
            this.rulefrom.annual = data;
            this.$refs.fifteenmain.searchmain(this.rulefrom);
        }
    }
};
</script>

<style lang="scss" scoped>
.chronicle {
    // overflow: hidden;
    padding-bottom: 80px;
    position: relative;
    .dzxcsc{
        position: absolute;
        right: 0;
        top: -90px;
        width: 100px;
    }
    .sides {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }
    .wire {
        margin-top: 38px;
        position: relative;
        .line {
            height: 1px;
            background-color: #ccc;
            width: 100%;
            width: 100%;
            margin-top: 100px;
            // margin-bottom: 100px;
        }
        .inner {
            display: flex;
            .main {
                flex: 1;
                position: relative;
                top: -47px;
                text-align: center;
                .circular {
                    cursor: pointer;
                    width: 60px;
                    height: 60px;
                    border-radius: 60px;
                    border: 2px solid #fabe00;
                    background-color: #fff;
                    margin-top: 15px;
                    position: relative;
                    left: 50%;
                    transform: translateX(-50%);
                    p {
                        font-size: 24px;
                        text-align: center;
                        width: 130px;
                        position: absolute;
                        left: -32px;
                        bottom: 78px;
                        transition: all 0.5s ease-in-out;
                    }
                    .p:hover {
                        transform: rotate(1.4);
                    }
                    .icon {
                        font-size: 32px;
                        // line-height: 104px;
                        // position: absolute;
                        // right: 14px;
                        // top: 12px;
                        line-height: 59px;
                        text-align: center;
                        color: #fabe00;
                    }
                    .icon-yunyingtongji {
                        font-size: 36px;
                    }
                    .icon-iconfontyingyongjiasu {
                        font-size: 36px;
                        margin-left: -3px;
                        margin-top: -7px;
                    }
                    transition: all 0.5s ease-in-out;
                }
                .active {
                    background-color: #fabe00;
                    .icon {
                        color: #fff;
                    }
                    p {
                        font-size: 32px;
                    }
                }
                .circular:hover {
                    background-color: #fabe00;
                    .icon {
                        color: #fff;
                    }
                    p {
                        font-size: 32px;
                    }
                }
            }
        }
    }
    .title {
        text-align: center;
        margin-top: 60px;
        font-size: 24px;
        margin-bottom: 0px;
    }
    // .slide-fade-enter-active {
    //     transition: all 2s ease;
    // }
    // .slide-fade-leave-active {
    //     transition: all 0s;
    // }
    // .slide-fade-enter {
    //     transform: translateY(300px);
    //     opacity: 0;
    // }
}
</style>
